import { DEAL_STAGES } from '@/helpers/hubspot/constants';
import { UpdateDealData } from '@/helpers/hubspot/types';
import profiler from '@/helpers/userProfile/profiler';
import { ReplaceInPersonFormState } from '../constants';

const updateHubspotDeal = async (
	state: ReplaceInPersonFormState,
): Promise<boolean> => {
	if (!state.hubspotDealId) throw new Error('Hubspot deal ID is missing');

	const [userProfile] = profiler();
	const isOutOfServiceArea = state.availableDealerCount === 0;

	const updateDealBody: UpdateDealData = {
		city: userProfile.city,
		dealname: `${state.firstName} ${state.lastName} - ${state.referenceId}`,
		dealstage: isOutOfServiceArea
			? DEAL_STAGES.OUT_OF_SERVICE // If there are no dealers in the area, set the deal stage to 'Out of Service'
			: DEAL_STAGES.INTAKE,
		experience: state.experience,
		full_address: state.address,
		message: state.message,
		model_number: state.modelNumber,
		model_type: state.modelType,
		state: userProfile.state,
		system_location: state.systemLocation,
		system_age: state.systemAge,
		model_size: state.modelSize,
		referral_source: state.referralSource,
		reference_id: state.referenceId,
		session_id: state.sessionId,
		system_issues: state.systemIssues?.join(', '),
		zip_code: userProfile.zip,
	};

	const deal = await fetch(`/api/hubspot/deal?id=${state.hubspotDealId}`, {
		method: 'PATCH',
		body: JSON.stringify(updateDealBody),
	})
		.then((res) => res.ok)
		.catch(() => false);
	return deal;
};

export default updateHubspotDeal;
